"use client";

import React from "react";
import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded-md" />)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-foreground hover:text-primary transition-colors text-sm font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const services = ["Seasonal Bouquets", "Potted Garden Plants", "Wedding Floral Design", "Event Decor Services", "Horticulture Workshops", "Sustainable Flower Subscriptions"];
  const socials = [{
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }, {
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }];
  const currentYear = new Date().getFullYear();
  return <section data-section-id="259885" id="footer" className="bg-background text-foreground pt-16 pb-8 border-t border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-12">
          {}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <WvcLogo className="h-8 w-auto" />
            </Link>
            <p className="text-foreground text-sm leading-relaxed max-w-xs font-default">
              PETAL is a family-owned garden and boutique shop blending modern floral artistry with sustainable, garden-grown traditions.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6 text-primary">Quick Links</h3>
            <MenuProvider menu_id="25">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6 text-primary">Our Offerings</h3>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="/ShopPage" className="text-foreground hover:text-primary transition-colors text-sm font-default">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6 text-primary">Visit Us</h3>
            <div className="flex flex-wrap gap-3">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Button key={i} data-index={i} variant="outline" size="icon" asChild className="rounded-md border-border hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300 shadow-sm">
                    <Link to={social.href} aria-label={social.label}>
                      <Icon className="size-4" />
                    </Link>
                  </Button>;
            })}
            </div>
          </div>
        </div>

        <Separator className="mb-8 bg-border" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-foreground font-default">
          <p>© {currentYear} PETAL Garden & Shop. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-primary transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-primary transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </section>;
}